import React, { useState, useEffect, useRef } from 'react'
import classnames from 'classnames'

import './index.scss'
import { ActivityIndicator, List } from 'antd-mobile'
import FailTips from '../FailTips'
import { generateCancelToken, isCancel } from '@/api/request'
import { cloneDeep } from 'lodash'
import { useFormatMessage } from '@/locales'

export interface AppListProps extends GT.ComponentProps {
  request?: Function
  row?: any
  type?: 'list' | 'custom'
  reFetch?: any
  requestParams?: any
  updateItem?: {
    key: string
    index: number
  }
  dataSource?: Array<never>
  prevProps?: any
  dataSourceParams?: any
}

let cancelToken: any

const ItemList = ({ source, row: Row, prevProps }: any) => (
  <>
    {source.map((item: any, index: React.Key | undefined) => (
      <Row source={item} index={index} key={index} prevProps={prevProps} />
    ))}
  </>
)

const AppList: React.FC<AppListProps> = props => {
  const {
    row: Row,
    request,
    type = 'list',
    reFetch = '',
    requestParams = '',
    updateItem,
    className,
    style,
    dataSource = [],
    prevProps,
    dataSourceParams = '',
  } = props
  const [source, setSource] = useState<any>([])
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)

  const intlMsg = useFormatMessage()

  const prevDataSourceParamsRef = useRef('')

  useEffect(() => {
    if (request) return
    setLoading(true)

    setSource(dataSource)

    // TODO: 暂时注释原来逻辑，mqtt 模式后可能不需要前端更新
    // if (prevDataSourceParamsRef.current !== dataSourceParams) {
    //   setSource(dataSource)
    // } else {
    //   setSource((prevSource: any) => {
    //     if (prevSource.length) {
    //       return prevSource.map((item: any) => {
    //         const index = dataSource.findIndex(
    //           (sourceItem: any) => sourceItem.sn === item.sn,
    //         )
    //         if (index !== -1) {
    //           return dataSource[index]
    //         }
    //         return item
    //       })
    //     }
    //     return dataSource
    //   })
    // }

    prevDataSourceParamsRef.current = dataSourceParams

    setLoading(false)
  }, [dataSource, dataSourceParams, request])

  useEffect(() => {
    fetchData()

    return () => {
      cancelToken && cancelToken.cancel()
    }
  }, [reFetch, requestParams])

  // TODO: 暂时注释原来逻辑，mqtt 模式后可能不需要前端更新
  useEffect(() => {
    if (updateItem) {
      const item: any = cloneDeep<any>(source[updateItem.index])

      if (updateItem.key === 'cloud') {
        item.cloud = 2
      }

      if (updateItem.key === 'addFav') {
        item.fav = '1'
      }

      if (updateItem.key === 'delFav') {
        item.fav = '0'
      }

      // if (updateItem.key === 'backend.tableOpenOprate.close') {
      //   item.room_status = 'close'
      // }

      // if (updateItem.key === 'backend.tableOpenOprate.open') {
      //   item.room_status = 'open'
      // }

      // if (updateItem.key === 'backend.tableOpenOprate.bill_flag') {
      //   item.bill_flag = item.bill_flag === '0' ? '1' : '0'
      // }

      // if (updateItem.key === 'backend.tableOpenOprate.room_r_flag') {
      //   item.room_r_flag = item.room_r_flag === '0' ? '1' : '0'
      // }

      const newSource = source.map((sourceItem: any, index: number) => {
        if (index === updateItem.index) {
          return item
        }
        return sourceItem
      })

      setSource(newSource)
    }
  }, [updateItem])

  const fetchData = async () => {
    if (!request) return

    cancelToken && cancelToken.cancel()
    cancelToken = generateCancelToken()

    setFetchError(false)
    setLoading(true)

    const data = await request(requestParams, {
      cancelToken: cancelToken.token,
    })
      .catch((e: any) => {
        console.log(e)
        if (isCancel(e.error)) return
        setFetchError(true)
      })
      .finally(() => {
        setLoading(false)
      })

    if (data) {
      setSource(data)
    }
  }

  // const ItemList = () => (
  //   <>
  //     {source.map((item: any, index: React.Key | undefined) => (
  //       <Row source={item} index={index} key={index} prevProps={prevProps} />
  //     ))}
  //   </>
  // )

  return (
    <div className="app-list-wrap">
      {loading && <ActivityIndicator text={intlMsg['tips.loading']} />}
      {fetchError && <FailTips buttonSize="small" onClick={fetchData} />}
      {!loading && !fetchError && source.length === 0 && (
        <p className="no-data-tips">{intlMsg['tips.no-data']}</p>
      )}
      <div
        className={classnames('app-list-inner', className)}
        style={{ ...style, visibility: loading ? 'hidden' : 'visible' }}
      >
        {type === 'list' ? (
          <List>
            <ItemList source={source} prevProps={prevProps} row={Row} />
          </List>
        ) : (
          <ItemList source={source} prevProps={prevProps} row={Row} />
        )}
      </div>
    </div>
  )
}

export default AppList
